import {React, useState,useEffect} from 'react';
import Popup from './Popup';
import Dropdown from './Dropdown';
import EditText from './EditText';
import Button from './Button';
import API_URLS from '../Urls';
import { useAuth } from './AuthProvider';
import Confirm from './Confirm';

const ViewClient = ({ client, onClose,onDelete }) => {
  const [address, setAddress] = useState({fiscal_address:0});
  const [clientData, setClientData] = useState(client)
  const [deletingClient, setDeletingClient] = useState(false)
  const [newAddressToSend, setNewAddressToSend] = useState({})
  const [newClientData,setNewClientData] = useState({})
  const [editingEnabled,setEditingEnabled] = useState(false)
  const [loading, setLoading] = useState(false);
  
  // Obtener permisos del usuario
  const { canWrite } = useAuth();
  const canWriteClientes = canWrite('acceso_clientes');

  const fetchData = (url,onSuccesful) => { // Función para obtener los datos
    setLoading(true);
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        onSuccesful(data)
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error)
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData(API_URLS.CLIENTS + "?id=" + client.id,data=>setClientData(data[0]));
  },[client])
  
  const putData = (url, dataToSend, onSuccesful) => { // Función para actualizar los datos
      fetch(url, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dataToSend)
      })
      .then(response => {
          if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
          return response.json();
      })
      .then(data => {
        onSuccesful(data)
      })
      .catch(error => console.error('There was a problem with the fetch operation:', error));
  }

  if (loading) {
    return (
      <Popup title="Cargando..." onClose={onClose}>
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ fontSize: '18px', color: '#666' }}>Cargando datos del cliente...</div>
        </div>
      </Popup>
    );
  }

  return (

    <Popup title={`Ver cliente: ${clientData?.nombre ?? "Desconocido"}`} onClose={onClose}>
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <div className='header1' style={{ marginBottom: '20px' }}>Información del cliente</div>
        {clientData ? (
          (() => {
            // Separar los campos en dos columnas
            const firstCol = Object.entries(clientData).slice(0, Math.ceil(Object.entries(clientData).length / 2));
            const secondCol = Object.entries(clientData).slice(Math.ceil(Object.entries(clientData).length / 2));
            
            return (
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '40px', width: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left', gap: '15px', flex: 1 }}>
                  {firstCol.map(([key, value], index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', gap: '10px', width: '100%' }}>
                      <span style={{ fontWeight: 'bold', minWidth: 'auto', textAlign: 'left' }}>{key}:</span>
                      { editingEnabled && key !== 'id' ? (
                        <EditText 
                          defaultText={value ?? ""} 
                          onChange={data=>{setNewClientData({...newClientData,[key]:data})}}
                          style={{ maxWidth: '250px', width: '250px' }}
                        />
                      ) : (
                        <div style={{ padding: '8px 12px', backgroundColor: '#f5f5f5', borderRadius: '4px', minWidth: '120px', maxWidth: '250px', textAlign: 'left' }}>
                           {value}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left', gap: '15px', flex: 1 }}>
                  {secondCol.map(([key, value], index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', gap: '10px', width: '100%' }}>
                      <span style={{ fontWeight: 'bold', minWidth: 'auto', textAlign: 'left' }}>{key}:</span>
                      { editingEnabled && key !== 'id' ? (
                        <EditText 
                          defaultText={value ?? ""} 
                          onChange={data=>{setNewClientData({...newClientData,[key]:data})}}
                          style={{ maxWidth: '250px', width: '250px' }}
                        />
                      ) : (
                        <div style={{ padding: '8px 12px', backgroundColor: '#f5f5f5', borderRadius: '4px', minWidth: '120px', maxWidth: '250px', textAlign: 'left' }}>
                           {value}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })()
        ) : (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '18px', color: '#666' }}>Cargando...</div>
          </div>
        )}
        <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '15px' }}>
          { !editingEnabled ? (
            canWriteClientes && (
              <div className='invisible-horizontal-container'>
              <Button text='Editar' onClick={()=>{setEditingEnabled(true);setNewClientData(clientData)}} style={{ color: 'Black' }}></Button>
              <Button text='Borrar' color='#8B0000' onClick={()=>{
                setDeletingClient(true)

              }}/>
              </div>
            )
          ) : (
            <Button text='Guardar' onClick={() => {
              putData(API_URLS.CLIENTS ,newClientData,()=>{
                setEditingEnabled(false);
                fetchData(API_URLS.CLIENTS + "?id=" + client.id,(data)=>setClientData(data[0]))
              });
            }} style={{ color: 'Black' }}></Button>
          )}
          {deletingClient &&(<div>
            <Confirm onDelete={()=>{
                onDelete()
            }} onCancel={()=>setDeletingClient(false)} message='¿Está seguro que quiere borrar este cliente de la base de datos?'/>
          </div>)}
        </div>
      </div>

    </Popup>
  );
};

export default ViewClient;


                